import { useEffect, useState } from 'react';
import axios from 'utils/axios.config';
import { AppLoader } from '../AppLoader';
import ServerError from '../ServerError/ServerError';

const fetchServerVersion = async () => {
  // const res = await axios.get('app-version', { timeout: 5000, timeoutErrorMessage: 'Server not responding' });
  // if (res.status !== 200) throw new Error(res.statusText);
};

export const ServerChecker = ({ children }: { children: React.ReactNode }) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchServerVersion().catch(() => {
        setError(true);
      });
      setLoading(false);
    })();
  }, []);
  if (loading) return <AppLoader />;
  if (error) return <ServerError />;
  return <>{children}</>;
};
